import * as React from 'react';
import _ from 'lodash';
import RuleBuilderConfig from './TreatmentRuleBuilderConfig';
import ShowConditions from 'components/rule-builder/ShowConditions';
import { Table } from 'semantic-grab-ui/src';
import { TwoCellRow } from 'components/custom';
import { SubScenario, Condition } from 'types/trident-campaigns';

interface Props {
  targetUserType: string,
  setRef: Function,
  scenario: SubScenario,
  listRuleTypes: Object,
}

// SubScenarioShow shows details of a single sub scenario
export default class SubScenarioShow extends React.Component<Props> {

  isEmptyOperator = (condition: Condition) => {
    const operator = _.get(condition, 'operator', '');
    return _.isEmpty(operator);
  }

  render() {
    const { targetUserType, scenario, listRuleTypes } = this.props;
    const eventType = scenario.eventType;
    const eventTypeData = _.find(_.get(listRuleTypes, targetUserType), { eventType });
    const eventTypeNoun = _.get(eventTypeData, 'noun');
    const ruleTypes = _.get(eventTypeData, 'ruleTypes', []);

    return (
      <div>
        <Table striped>
          <Table.Body>
          {
            <TwoCellRow
              firstCell="Name"
              secondCell={`${scenario.name || eventTypeNoun}`}
            />
          }
          <TwoCellRow
            firstCell="Event"
            secondCell={`${scenario.noun || eventType}`}
          />
            {
              !_.isEmpty(_.get(scenario, 'currency')) &&
              <TwoCellRow
                firstCell="Currency"
                secondCell={_.get(scenario, 'currency')}
              />
            }
            {
              (_.isEmpty(scenario.condition) || this.isEmptyOperator(scenario.condition)) &&
              <TwoCellRow
              firstCell="Condition"
              secondCell="Not Set"
              />
            }
          </Table.Body>
        </Table>

        {(!_.isEmpty(eventType) && !_.isEmpty(scenario.condition) && !this.isEmptyOperator(scenario.condition)) &&
          <ShowConditions
            setRef={this.props.setRef}
            model={scenario.condition}
            config={RuleBuilderConfig}
            type={`TREATMENTS.${eventType}`}
            hideTitle
            systemType="newtrident"
            ruleTypes={ruleTypes}
            ruleTypesPassedFromSystem
          />
        }
      </div>
    );
  }
}
